import { Skeleton } from '@/components/ui/loading/skeleton';
import { tv } from '@/utils/styles';

const FlightServicesSkeleton = () => {
  const { base, row, cell } = styles();

  return (
    <div className={base()}>
      {[...Array(5).keys()].map((item) => (
        <div className={row()} key={item}>
          <Skeleton className={cell()} />
          <Skeleton className={cell()} />
          <Skeleton className={cell()} />
          <Skeleton className={cell()} />
          <Skeleton className={cell()} />
          <Skeleton className={cell()} />
        </div>
      ))}
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'pb-2 pb-4',
    row: 'mx-4 my-2 flex flex-row justify-between gap-10 rounded border border-grey-200 bg-white px-4 py-6',
    cell: 'h-4 w-full max-w-40',
  },
});

export { FlightServicesSkeleton };
